import * as React from "react"
const Fire2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={29}
    fill="none"
    {...props}
  >
    <path
      fill="#BDDEFF"
      d="M10.528.07a1 1 0 0 1 .885.073c5.688 3.422 10.942 9.265 12.663 14.898.868 2.84.865 5.732-.581 8.213-1.445 2.478-4.213 4.345-8.448 5.384a1 1 0 0 1-.989-1.633c1.732-1.965 3.263-4.261 3.486-6.68.17-1.842-.408-3.928-2.625-6.148.016 2.362-.893 4.33-1.81 5.455a1 1 0 0 1-1.756-.436c-.366-1.832-1.407-2.639-2.516-3.207-.075 1.561-.756 2.685-1.251 3.502a9.36 9.36 0 0 0-.358.623c-1.474 2.948.311 5.089 1.546 6.57.102.12.2.238.291.351a1 1 0 0 1-1.124 1.569c-3.818-1.42-6.519-4.08-7.519-7.326-1.006-3.266-.235-6.945 2.539-10.254.89-1.061 1.667-1.942 2.351-2.717C7.72 5.58 8.978 4.154 9.934.731a1 1 0 0 1 .594-.66Z"
    />
  </svg>
)
export default Fire2
